














































import { Vue, Component, Prop } from 'vue-property-decorator';
import BackgroundCoin from '@/components/icons/BackgroundCoin.vue';
import {
  calculateResizeMargin,
  calculateResizePercentage
} from '@/utils/resize';

type TType = 'default' | 'percentage';

const componentSize = 75;

@Component({
  components: {
    BackgroundCoin
  }
})
export default class RewardCoin extends Vue {
  @Prop(String) value!: string;
  @Prop({ default: 'default' }) type!: TType;
  @Prop({ default: '75' }) size!: string;

  get textValue() {
    return this.value;
  }

  get countryData() {
    return this.$store.getters['internationalization/getCountrySettings'];
  }

  get currencySymbol() {
    return this.countryData.currencySymbol;
  }

  get isPercentage() {
    return this.type === 'percentage';
  }

  get calculateSize() {
    return calculateResizePercentage(componentSize, this.size);
  }

  get calculateMargin() {
    return calculateResizeMargin(componentSize, this.size);
  }
}
